import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectAppointmentServices,
  selectAppointmentServicesSum,
  selectStartedAtConfirm,
} from '@modules/booking/store/appointment';

@Component({
  selector: 'pub-mobile-appointment-table',
  templateUrl: './mobile-appointment-table.component.html',
  styleUrls: ['./mobile-appointment-table.component.scss'],
})
export class MobileAppointmentTableComponent {
  appointmentServicesSum$ = this.store.select(selectAppointmentServicesSum);
  appointmentServices$ = this.store.select(selectAppointmentServices);
  startDate$ = this.store.select(selectStartedAtConfirm);

  constructor(private store: Store) {}
}
